import { ChangeEvent, FC, useEffect, useMemo, useState } from "react";

import { Button, Input, Modal } from "antd";
import debounce from "lodash.debounce";

import { useAppDispatch, useAppSelector } from "store";
import { getContractorsSelector } from "store/contractors/contractors.selector";
import { updateContractorsFilter, updateContractorsPagination } from "store/contractors/contractors.actions";
import { getContractors } from "store/contractors/contractors.thunks";
import { ContractorForm } from "components/contractors";
import searchIcon from "data/icons/search.svg";

const ContractorsHeader: FC = () => {
  const dispatch = useAppDispatch();
  const { filter } = useAppSelector(getContractorsSelector);

  const [ isContractorModalOpen, setContractorModalOpen ] = useState(false);

  const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch(updateContractorsFilter({
      search: e.target.value,
    }))
  }

  const updateInfo = () => {
    dispatch(updateContractorsPagination(1));
    dispatch(getContractors());
  }

  const debouncedResults = useMemo(() => {
    return debounce(updateInfo, 400);
  }, [])

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    }
  }, [])

  return (
    <div className="contracts-header-wrapper">
      <Button
        type="primary"
        onClick={ () => setContractorModalOpen(true) }
      >
        + Add contractor
      </Button>

      <Input
        value={ filter.search }
        prefix={ <img src={ searchIcon } alt="" /> }
        placeholder="Search"
        className="search-input"
        onChange={ (e) => {
          handleChangeSearch(e);
          debouncedResults();
        } }
      />

      <Modal
        open={ isContractorModalOpen }
        onCancel={ () => setContractorModalOpen(false) }
        footer={ null }
        width={ 500 }
        title="Add contractor"
      >
        <div style={ { padding: 20 } }>
          <ContractorForm onClose={ () => setContractorModalOpen(false) } />
        </div>
      </Modal>
    </div>
  )
}

export default ContractorsHeader;
